// Personal libs
import { Repository } from './common/repository.class';
import { ApiError } from '@shared/error/api.error';
import { IApiResponse } from '@shared/interface/api-response.interface';
import {
  apiPostMessage,
  IApiPostMessage,
} from '@data/datasource/remote/contact.api';
import { $t } from '@i18n/utils';
import { sessionManager } from '@shared/service/sessionManager/session-manager.class';

class ContactRepository extends Repository {
  constructor() {
    super();
  }

  /*****************************************
   *
   * POST FUNCTIONS
   *
   *****************************************/
  // Send an email to the admins
  postMessage(
    params?: IApiPostMessage,
  ): Promise<IApiResponse<string, string> | undefined> {
    if (sessionManager.isOnline.value && params != null) {
      return apiPostMessage(params).catch((err: ErrorConstructor) => {
        if (err instanceof ApiError) {
          const messageToThrow = $t(`contact.msg.${err.code}`);
          if (messageToThrow !== `contact.msg.${err.code}`) {
            throw new Error(messageToThrow);
          } else {
            throw new Error('Erreur inconnue');
          }
        } else {
          throw new Error('Erreur inconnue');
        }
      });
    } else {
      throw new Error($t('generic.hasToBeOnline'));
    }
  }
}

export default new ContactRepository();
